export const formatBRL = (amount: number): string =>
  amount.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
